export const getFormattedDate = (
  dateString: string | number,
  options?: Object | undefined
) => {
  return new Date(dateString).toLocaleDateString(
    'en-US',
    options ?? {
      month: 'long',
      day: 'numeric',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    }
  );
};

export function isJson(item: string) {
  item = typeof item !== 'string' ? JSON.stringify(item) : item;

  try {
    item = JSON.parse(item);
  } catch (e) {
    return false;
  }

  if (typeof item === 'object' && item !== null) {
    return true;
  }

  return false;
}
